import { render, staticRenderFns } from "./statistics_data.vue?vue&type=template&id=13b42a48"
import script from "./statistics_data.vue?vue&type=script&lang=js"
export * from "./statistics_data.vue?vue&type=script&lang=js"
import style0 from "./statistics_data.vue?vue&type=style&index=0&id=13b42a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports